import React from "react";
import "../App.css";
import { useNavigate } from "react-router-dom";

function SquadStrike() {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: "center" }}>
      <h1 className="main-title">Squad Strike</h1>
      <br /><br /><br />

      <p style={{ marginTop: "40px", fontSize: "1.2rem" }}>
        This is the Squad Strike page. Build your squad battles here!
      </p>
    </div>
  );
}

export default SquadStrike;
